import { initSubRoutes } from '../../../utils/router';

const RoutesMentionsLegales = initSubRoutes({
    route: '/mentions-legales',
    subroutes: {},
    nom: 'Mentions légales',
});

export default RoutesMentionsLegales;
